import React, { Component } from 'react';

// TODO: rewrite component to functional, because it stateless
// eslint-disable-next-line react/prefer-stateless-function
export default class Home extends Component {
  render() {
    return (
      <div className="Home" style={{ padding: '80px 0', textAlign: 'center' }}>
        <div className="lander">
          <h1
            style={{ fontFamily: 'Open Sans, sans-serif', textAlign: 'center' }}
          >
            FF-CMS
          </h1>
          <p style={{ color: '#999' }}>A simple insight into the field</p>
        </div>
      </div>
    );
  }
}
